import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { useSelector } from 'react-redux';
import { themeGet } from '@styled-system/theme-get';
import { isAdmin } from '../../lib/utils/roles';

const GlobalStyle = createGlobalStyle`
  body {
    padding-right: 0 !important;

    .content {
      padding: 0;
      transition: width 0.3s ease-in-out;

      ${themeGet('mediaQueries.forMediumUp')} {
        width: ${({ locked, showingNavBar }) => {
          if (!showingNavBar) return '100%';

          return locked ? 'calc(100% - 200px)' : 'calc(100% - 65px)';
        }};
         margin: ${({ showingNavBar }) =>
           showingNavBar ? '0 0 0 auto' : '0 auto'};
      }
    }

    .swal2-content {
      padding: 0;
    }

    .swal2-popup {
      padding: 0;
      border-radius: 8px;
    }

    .swal2-html-container {
      margin: 0;
      overflow: visible;
    }

    // tinymce dialog styles
    .tox .tox-dialog {
      border-radius: 8px;
      border: none;
    }

    .tox .tox-textfield {
      border-radius: 8px;
    }

    .tox .tox-dialog__header {
      color: ${themeGet('colors.black.100')};
    }

    .tox .tox-dialog__footer {
      border: none;
    }

    .tox .tox-button {
      border-radius: 8px;
      padding: 10px 24px;

      background-color: ${themeGet('colors.primary.100')};
      color: ${themeGet('colors.white')};

      &:hover:not(:disabled) {
        background-color: ${themeGet('colors.primary.100')};
        color: ${themeGet('colors.white')};
      }
    }
    .tox .tox-button--icon, .tox .tox-button.tox-button--icon, .tox .tox-button.tox-button--secondary.tox-button--icon {
      background-color: transparent;
      color: ${themeGet('colors.black.100')};

      &:hover:not(:disabled) {
        background-color: transparent;
        color: ${themeGet('colors.black.100')};
      }
    }

    .tox .tox-button--secondary {
      border: solid 1px;
      border-color: ${themeGet('colors.black.80')};
      color: ${themeGet('colors.black.80')};
      background-color: ${themeGet('colors.white')};

      &:hover:not(:disabled) {
        color: ${themeGet('colors.black.80')};
        border: solid 1px;
        border-color: ${themeGet('colors.black.80')};
        background-color: ${themeGet('colors.white')};
      }
    }

    .tox .tox-textfield,
    .tox .tox-dialog__title,
    .tox .tox-button,
    .tox-tinymce,
    .tox .tox-label {
      font-family: 'Montserrat';
    }


    .tox-tiered-menu {
      font-family: 'Montserrat', sans-serif !important;

      .tox-menu.tox-collection.tox-collection--list {
        padding: 0;
        border: 0;
        margin-top: 5px;

        .tox-collection__group {
          padding: 0;

          .tox-collection__item--active {
            background-color: ${themeGet('colors.primary.10')};
            color: ${themeGet('colors.primary.100')};
          }
        }
      }
    }
  }
`;

const GlobalStyleWrapper = () => {
  const { locked } = useSelector(state => state.navBarCollapse);
  const { userType } = useSelector(state => state.currentUser);

  return (
    <>
      <GlobalStyle locked={locked} showingNavBar={isAdmin(userType)} />
    </>
  );
};

export default GlobalStyleWrapper;
